import Fuse from "fuse.js";
export default {
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        return this.pagedData;
      }

      const query = this.normalize(this.searchQuery);

      let result = this.tableData.filter((row) => {
        return this.propsToSearch.some((key) => {
          const rawValue = row[key];
          if (!rawValue) return false;

          const normalizedValue = this.normalize(rawValue.toString());
          return normalizedValue.includes(query);
        });
      });

      // 🔽 Ordenar por gasto_total (descendente)
      result.sort((a, b) => {
        const aVal = parseFloat(a.gasto_total) || 0;
        const bVal = parseFloat(b.gasto_total) || 0;
        return bVal - aVal; // DESC
      });

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 500],
        total: 0,
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: "",
    };
  },
  methods: {
    normalize(str) {
      return str
        .toLowerCase()
        .normalize("NFD") // separa letras de acentos
        .replace(/[\u0300-\u036f]/g, ""); // remove acentos
    },
    sortChange({ prop, order }) {
      if (prop && order) {
        this.tableData.sort((a, b) => {
          let aVal = a[prop];
          let bVal = b[prop];

          // Garante que nulls ou undefined não quebram
          if (aVal === null || aVal === undefined) aVal = "";
          if (bVal === null || bVal === undefined) bVal = "";

          // Para números e strings — usa localeCompare para strings
          if (typeof aVal === "string" && typeof bVal === "string") {
            return order === "ascending"
              ? aVal.localeCompare(bVal)
              : bVal.localeCompare(aVal);
          } else {
            return order === "ascending" ? aVal - bVal : bVal - aVal;
          }
        });
      } else {
        // Reset para ordem original (ou por gasto_total por padrão)
        this.tableData.sort((a, b) => b.gasto_total - a.gasto_total);
      }
    },
  },
};
